import { Modal } from "../../components/Modal";

export const WORK_TIP =
  "Each session is labelled by what its tool calls did. Coding edits files, Exploration mostly reads code, Shell & ops mostly runs commands, Chat & planning makes few tool calls, and Mixed is a bit of everything.";

export const LITE_TIP =
  "Condense Lite: lighter compression, up to 20% of each prompt, that runs after the weekly allowance is used up and until it resets.";

const TERMS: { term: string; text: string }[] = [
  {
    term: "List-price spend",
    text: "Spend at API prices shows total price: input price plus output price. Input includes prompt tokens and cache reads and writes; output is the price of generated tokens. Analytics lets you select Input price, Output price or Total price. Subscription usage is valued at API prices, not charged again.",
  },
  {
    term: "Billed per token",
    text: "Traffic on API keys the provider bills per token. This is money that leaves the company as it is used.",
  },
  {
    term: "Covered by subscriptions",
    text: "Traffic on flat subscriptions (Claude Max, ChatGPT plans). You pay the subscription, not this amount; it is what the same tokens would cost on the API, so subscription and billed usage add up on one scale.",
  },
  {
    term: "Money saved",
    text: "The provider cost condense took off by compressing context before it was sent, measured against the same requests with optimal prompt caching, request by request. Requests condense passes through untouched save nothing; the figure can be slightly negative when compression invalidates a warm cache.",
  },
  {
    term: "Tokens saved / Compression",
    text: "Tokens condense removed before they reached the provider, and that as a share of input tokens before compression. Money-saved percentages divide savings by input spend plus savings; output costs are excluded.",
  },
  {
    term: "Tokens kept off / Plan stretch",
    text: "On a Claude or ChatGPT subscription, the tokens condense removed never count against the plan's 5-hour and weekly limits. Stretch is how much more work fits in each window because of that.",
  },
  {
    term: "condense fee",
    text: "What condense charges for compressing per-token API traffic, paid from credits. What you keep is the money saved minus this fee.",
  },
  {
    term: "Cache hit",
    text: "The share of prompt tokens the provider served from its cache at a fraction of the price. Long breaks between turns let the cache expire, so the next turn re-writes the whole context.",
  },
  {
    term: "Session",
    text: "One run of a coding agent started through the dense CLI, with its repository, branch and ticket.",
  },
  {
    term: "Type of work",
    text: WORK_TIP,
  },
  {
    term: "Agent / Agent version",
    text: "Agent is the coding tool (Claude Code, Codex, OpenCode); agent version is the exact build that sent the request.",
  },
  {
    term: "Plan allowance",
    text: "How much of your condense plan's weekly compression you have used. It is condense's own allowance, separate from provider spend and from your Claude or ChatGPT plan's limits.",
  },
  {
    term: "Condense Lite",
    text: "Lighter compression, up to 20% of each prompt, that runs after the weekly plan allowance is used up and until it resets.",
  },
  {
    term: "Zero data retention (ZDR)",
    text: "When it is on, condense never stores conversation content, only the billing metadata of each request. Sessions are not tracked.",
  },
  {
    term: "Budget",
    text: "A spend limit for the organization, a team, a person or a model, per week or month. At the limit it warns admins, blocks requests, or needs an admin to approve a raise.",
  },
  {
    term: "Ranges and changes",
    text: "Every page uses the range picked in its header. A % change compares it with the period of the same length just before.",
  },
];

/** What every number on the analytics pages means, in one place. */
export function Glossary({ onClose }: { onClose: () => void }) {
  return (
    <Modal title="How the numbers work" onClose={onClose} wide>
      <dl className="ins-glossary">
        {TERMS.map((t) => (
          <div key={t.term}>
            <dt>{t.term}</dt>
            <dd>{t.text}</dd>
          </div>
        ))}
      </dl>
    </Modal>
  );
}
